module.exports = __webpack_public_path__ + "static/media/support.b020a784.webp";